import React from "react";
import { object, func } from "prop-types";
import "../thumb/PlaceholderThumb";
import Col from "../grid/Col";
import Row from "../grid/Row";
import PlaceholderThumb from "../thumb/PlaceholderThumb";
import Button from "../button/Button";

import "./UserCard.css";

const UserCard = ({ user, onDelete, onEdit, onUserBoxClick }) => {
	return (
		<div onClick={onUserBoxClick}>
			<Col user-card>
				<div className="thumbnail">
					{user.profile_photo_url ? (
						<img src={user.profile_photo_url} alt="" />
					) : (
						<PlaceholderThumb
							firstName={user.first_name}
							lastName={user.last_name}
							size={96}
							contactDefaultPhoto={user.color}
						/>
					)}
				</div>

				<Col _bottom-8 card-content>
					<div>
						<h2>
							{user.first_name} {user.last_name}
						</h2>
					</div>
					<Col _bottom-4>
						<div className="key">phone</div>
						<div className="value">{user.phone}</div>
					</Col>

					<Col _bottom-4>
						<div className="key">email</div>
						<div className="value">{user.email}</div>
					</Col>
				</Col>

				<Row _no-grow _gap-8 card-buttons>
					{onEdit && (
						<Button onClick={onEdit} className={"btn-plain"}>
							EDIT
						</Button>
					)}
					{onDelete && (
						<Button onClick={onDelete} className={"btn-plain btn-red-text"}>
							DELETE
						</Button>
					)}
				</Row>
			</Col>
		</div>
	);
};

UserCard.propTypes = {
	onDelete: func,
	onEdit: func,
	onUserBoxClick: func,
	user: object
};

export default UserCard;



// WEBPACK FOOTER //
// ./src/common/userCard/UserCard.js